import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Comment } from "models/Comment";
import { toast } from "react-toastify";
import { useDeleteInternalCommentMutation } from "app/api/checklists";
import { useChecklistContext } from "context/ChecklistContext";

type DeleteCommentDialogProps = { onClose: () => void; comment: Comment };

const DeleteCommentDialog: React.FC<DeleteCommentDialogProps> = (props) => {
  const { checklist } = useChecklistContext();
  const { onClose, comment } = props;
  const [deleteInternalComment, { isLoading }] = useDeleteInternalCommentMutation();

  const handleSave = async () => {
    deleteInternalComment({ checklistId: checklist.id, commentId: comment.id })
      .unwrap()
      .then(() => onClose())
      .catch((error) => {
        console.error(error);
        toast.error("Kunde inte radera kommentaren. Försök igen senare.");
      });
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Radera kommentar?</DialogTitle>

      <DialogActions>
        <Button variant="outlined" disabled={isLoading} onClick={onClose}>
          Avbryt
        </Button>
        <Button variant="contained" color="error" loading={isLoading} onClick={handleSave}>
          Radera
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCommentDialog;
